import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/content_copy.svg'
import _imports_1 from '@/assets/images/delete_FILL.svg'


const _hoisted_1 = {
  key: 2,
  class: "action-info-block"
}
const _hoisted_2 = { class: "action-info default-text" }
const _hoisted_3 = { class: "task-name-view-block default-text" }
const _hoisted_4 = {
  key: 0,
  class: "second-action-info-block"
}
const _hoisted_5 = { class: "info-time-block default-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitEdition())),
    class: "info-item"
  }, [
    (!_ctx.allEntryView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["info-role default-text", _ctx.taskInfo.role])
        }, _toDisplayString(_ctx.roleLabel(_ctx.taskInfo.role)), 3))
      : _createCommentVNode("", true),
    (_ctx.allEntryView)
      ? (_openBlock(), _createBlock(_component_tooltip, {
          key: 1,
          class: "all-entry-role-tooltip",
          positionFromTop: _ctx.postitionSmall,
          text: _ctx.tooltipLabels(_ctx.taskInfo.role)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["info-role default-text", _ctx.taskInfo.role])
            }, _toDisplayString(_ctx.roleLabel(_ctx.taskInfo.role)), 3)
          ]),
          _: 1
        }, 8, ["positionFromTop", "text"]))
      : _createCommentVNode("", true),
    (!_ctx.allEntryView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tooltipActions), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.allEntryView)
      ? (_openBlock(), _createBlock(_component_tooltip, {
          key: 3,
          positionFromTop: _ctx.postitionSmall,
          text: _ctx.taskName
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.taskInfo.name), 1)
          ]),
          _: 1
        }, 8, ["positionFromTop", "text"]))
      : _createCommentVNode("", true),
    _createVNode(_component_tooltip, {
      class: "second-action-info-block-tooltip",
      positionFromTop: _ctx.postitionSmall,
      text: _ctx.tooltipActions
    }, {
      default: _withCtx(() => [
        (_ctx.allEntryView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionWordArray, (action, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "action-info default-text",
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(action) + " ", 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["positionFromTop", "text"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_ctx.getTotalTime), 1)
    ]),
    (!_ctx.allEntryView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "duplicate-button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emitDuplication()), ["stop"]))
        }, [
          _createVNode(_component_tooltip, {
            text: _ctx.duplicateTooltipText,
            positionFromTop: 'small'
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["text"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.allEntryView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "deletion-button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emitDelition()), ["stop"]))
        }, [
          _createVNode(_component_tooltip, {
            text: _ctx.deleteTooltipText,
            positionFromTop: 'small'
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["text"])
        ]))
      : _createCommentVNode("", true)
  ]))
}